import React from 'react'
import styled from 'styled-components/macro'
import { MobileBackIcon } from '../BackIcon/MobileBackIcon'

type MobileHeaderProps = {
  title: string
  onBack: () => void
} & React.HTMLAttributes<HTMLDivElement>

export const MobileHeader = (props: MobileHeaderProps) => {
  return (
    <Container>
      <IconContainer onClick={props.onBack}>
        <MobileBackIcon />
      </IconContainer>
      <NavHeader children={props.title} />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 12px;
`

const NavHeader = styled.div`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
  text-align: left;
  flex: 1;
  margin-left: 12px;
`

const IconContainer = styled.div`
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
